/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1BalanceSnapshotEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.BalanceSnapshotEvent';
export const ixcPortfolioV1BalanceSnapshotEventEntity = new schema.Entity<IxcPortfolioV1BalanceSnapshotEvent>(IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1BalanceSnapshotEvent) => `${entity.metadata?.eventId}` });

